import { useStrings } from '../i18n/context';

/**
 * The visible notice that interpretation and notes process speech (ADR 001, Privacy).
 * Full in the lobby, before anyone joins; one line with the details folded in the room.
 * Its wording must stay true to ADR 001: change both together.
 */
export function PrivacyNotice({ compact = false }: { readonly compact?: boolean }) {
  const strings = useStrings();
  if (compact) {
    return (
      <details className="privacy privacy--compact">
        <summary>
          {strings.privacyShort} <span className="privacy__more">{strings.privacyDetails}</span>
        </summary>
        <p>{strings.privacyNotice}</p>
      </details>
    );
  }
  return (
    <section className="privacy" aria-labelledby="vm-privacy-heading">
      <h2 id="vm-privacy-heading">{strings.privacyHeading}</h2>
      <p>{strings.privacyNotice}</p>
    </section>
  );
}
